//codex-- Page-scoped toolbar layout; retain this project's handlers and data.
import PageToolbar, { ToolbarField } from './PageToolbar';
import React, { useState } from "react"
import axios from "axios"
import { toast } from "react-toastify"
import BuildingStats from "../components/BuildingStats"
import HeadingCp from "../components/HeadingCp"

export default function BuildingHubPage() {
  const [query, setQuery] = useState("")
  const [searching, setSearching] = useState(false)
  const [buildingData, setBuildingData] = useState(null)
  const apiUrl = process.env.REACT_APP_API_URL

  const handleSearch = async (e) => {
    e && e.preventDefault()
    if (!query.trim()) {
      toast.info("Type an address to search.", { position: "top-center" })
      return
    }

    try {
      setSearching(true)
      setBuildingData(null)

      const res = await axios.post(`${apiUrl}/building_hub.php`, {
        query: query.trim(),
      })
      console.log(res.data);
      
      if (res.data && res.data.error) {
        toast.error(res.data.error, { position: "top-center" })
        return
      }

      setBuildingData(res.data)
    } catch (err) {
      console.error(err)
      toast.error("Error searching buildings.", { position: "top-center" })
    } finally {
      setSearching(false)
    }
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="mx-auto max-w-7xl p-4 sm:p-6 lg:p-8">
        {/* Search */}
       {/* PAGE TITLE */}
        <div className="mb-6">
          <HeadingCp label="Building Overview" />
          <p className="mt-2 text-sm text-gray-500">
            Search for a building address and view all linked contracts, jobs, service
            calls, proposals, and hours.
          </p>
        </div>

        {/* SEARCH BAR */}
        <>{/* //codex-- Match this page's toolbar to its asmainframe reference. */}<PageToolbar title="Building search tools">
            <form onSubmit={handleSearch} className="mb-4 flex flex-col gap-3 sm:flex-row bg-white rounded-md border border-gray-300 p-4 shadow-sm max-w-2xl">
              <div className="page-toolbar-row">
                <ToolbarField label="Search"><input type="text" value={query} onChange={e => setQuery(e.target.value)} placeholder="Search by address, building name, or site ID..." className="block w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 shadow-sm placeholder:text-gray-400 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500" /></ToolbarField>
              </div>
              <button type="submit" disabled={searching} className="inline-flex items-center justify-center rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-60">
                {searching ? "Searching..." : "Search"}
              </button>
            </form>
          </PageToolbar></>

        {/* Loading / Result */}
        {searching && (
          <div className="rounded-xl border bg-white p-6 text-sm text-gray-500">
            Loading building overview...
          </div>
        )}

        {!searching && buildingData && <BuildingStats buildingData={buildingData} />}

        {!searching && !buildingData && (
          <div className="rounded-xl border bg-white p-6 text-xs text-gray-400">
            Enter an address above to view the building overview.
          </div>
        )}
      </div>
    </div>
  )
}
